import { AUTH_TOKEN_KEY } from '@/lib/constants/authentication'

const setUserSession = (userSession) => {
  localStorage.setItem(AUTH_TOKEN_KEY, JSON.stringify(userSession))
}

export default setUserSession
